/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Trending_ShortInputs */

const en_header_trending_short = /** @type {(inputs: Header_Trending_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trending`)
};

/**
* | output |
* | --- |
* | "Trending" |
*
* @param {Header_Trending_ShortInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const header_trending_short = /** @type {((inputs?: Header_Trending_ShortInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Trending_ShortInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_trending_short(inputs)
});
export { header_trending_short as "header.trending.short" }